import { createSelector, createSelectorCreator, defaultMemoize, isEqual } from 'reselect';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

export const getSingleLicense = createDeepEqualSelector(
  (state) => state.app.getIn(['licenses','singleLicense']).toJS(), res => res
);

export const getLicenseSeatInvitations = createSelector(
  (state) => state.invitations.getIn(['pendingLicenseSeatInvites']).toJS(), res => res
);
